import { DefaultSettings, ErrorMessage } from '@as-react/common-types';
import { checkVAT, countries } from 'jsvat-next/lib/es6';
import * as Yup from 'yup';
import { mapWithAssert } from '../../../util/ArrayUtil';
import { generateFieldName, getAddressValidationSchema } from '../address-fields/addressFields.utils';
export var InvoiceFieldName;
(function (InvoiceFieldName) {
    InvoiceFieldName["VAT_NUMBER"] = "vatNumber";
    InvoiceFieldName["TECH_ADDRESS"] = "techAddress";
    InvoiceFieldName["COMPANY_NAME"] = "companyName";
    InvoiceFieldName["COMPANY_DEPARTMENT"] = "companyDepartment";
    InvoiceFieldName["ADDRESS"] = "address";
})(InvoiceFieldName || (InvoiceFieldName = {}));
export const isDisabledVatNumberField = (info) => { var _a, _b; return !!((_a = info.customerDetails) === null || _a === void 0 ? void 0 : _a.vatNumber) && ((_b = info.customerDetails.invoiceAddress) === null || _b === void 0 ? void 0 : _b.idCountry) === info.idCountry; };
export const getInvoiceValidationSchema = ({ t, country, fullVatFormEnabled = false, withAddress = true, }) => {
    const [vatNumberField, techAddressField, companyNameField, companyDepartmentField, addressField] = mapWithAssert([
        InvoiceFieldName.VAT_NUMBER,
        InvoiceFieldName.TECH_ADDRESS,
        InvoiceFieldName.COMPANY_NAME,
        InvoiceFieldName.COMPANY_DEPARTMENT,
        InvoiceFieldName.ADDRESS,
    ], name => generateFieldName(name));
    const defaultRequiredMessage = t(ErrorMessage.ACCOUNT_REQUIRED);
    return fullVatFormEnabled
        ? // needInvoice fullVatFormEnabled
            Yup.object(Object.assign({ [vatNumberField]: Yup.string()
                    .required(defaultRequiredMessage)
                    .test('checkVAT', t(ErrorMessage.INVALID_VAT_NUMBER), value => {
                    const currentCountry = country
                        ? countries.find(item => item.codes.includes(country.toUpperCase()))
                        : undefined;
                    return currentCountry ? checkVAT(value, [currentCountry]).isValid : false;
                }), [techAddressField]: Yup.string()
                    .transform(currentValue => (currentValue === '' ? undefined : currentValue))
                    .matches(new RegExp(DefaultSettings.PEPPOL_ID_REGEX), t(ErrorMessage.INVALID_PEPPOL_ID)), [companyNameField]: Yup.string().required(defaultRequiredMessage), [companyDepartmentField]: Yup.string() }, (withAddress && { [addressField]: getAddressValidationSchema({ t, country }) })))
        : // alternateInvoiceAddress
            Yup.object({
                [addressField]: getAddressValidationSchema({ t, country }),
            });
};
